export default function Footer() {
  const socialLinks = [
    { name: 'Instagram', icon: 'ri-instagram-line', url: 'https://www.instagram.com/canadiannightmares/', color: '#E4405F' },
    { name: 'YouTube', icon: 'ri-youtube-line', url: 'https://music.youtube.com/channel/UCRHeGip8UYcbnkGqumRjV8Q', color: '#FF0000' },
    { name: 'Spotify', icon: 'ri-spotify-line', url: 'https://open.spotify.com/artist/4KZKossrGlEQi3uNx4UhBr?si=vx4Nn1C2Qs6Bp7IVDuSFPA', color: '#1DB954' },
  ];

  const streamingPlatforms = [
    { name: 'Spotify', icon: 'ri-spotify-fill', url: '#' },
    { name: 'Apple Music', icon: 'ri-music-fill', url: '#' },
    { name: 'YouTube Music', icon: 'ri-youtube-fill', url: '#' },
    { name: 'SoundCloud', icon: 'ri-soundcloud-fill', url: '#' },
    { name: 'Bandcamp', icon: 'ri-disc-fill', url: '#' }
  ];

  return (
    <footer className="relative bg-[#080808] pt-20 pb-8 px-6 md:px-12 lg:px-24">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16">
          {/* Left Column - Logo */}
          <div className="flex flex-col items-start">
            <img
              src="https://static.readdy.ai/image/4290f71dfbaa025f6a9f1c6e0e6bc4ce/ca8beac7fb2d325d3e1a06ffdb5d3223.png"
              alt="Canadian Nightmares"
              className="h-20 w-auto mb-4 logo-glow"
            />
            <p className="text-sm text-white font-bold tracking-wider">CANADIAN NIGHTMARES</p>
            <p className="text-xs text-gray-500 mt-2">Just be Canadian</p>
          </div>

          {/* Center Column - Social Links */}
          <div className="flex flex-col items-start md:items-center">
            <h3 className="text-xs tracking-widest text-gray-400 uppercase mb-6">Follow</h3>
            <div className="flex gap-4">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.url}
                  className="w-10 h-10 flex items-center justify-center text-white/60 hover:text-white transition-all duration-300 group"
                  aria-label={social.name}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.filter = `drop-shadow(0 0 8px ${social.color})`;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.filter = 'none';
                  }}
                >
                  <i className={`${social.icon} text-2xl`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Right Column - Copyright & Streaming */}
          <div className="flex flex-col items-start md:items-end">
            <p className="text-xs text-gray-400 mb-2">© 2025 CANADIAN NIGHTMARES</p>
            <p className="text-[10px] text-gray-600 mb-6">ALL RIGHTS RESERVED</p>
          </div>
        </div>

        {/* Bottom Border */}
        <div className="relative pt-8 border-t border-gray-900">
          <div className="absolute bottom-0 left-0 right-0 h-px bg-[#ff0033] pulse-border-bottom"></div>
          <p className="text-center text-xs text-gray-600">
            Designed for the darkness. Built for the night.
          </p>
        </div>
      </div>
    </footer>
  );
}